import script from "./LP09.vue?vue&type=script&setup=true&lang=js"
export * from "./LP09.vue?vue&type=script&setup=true&lang=js"

import "./LP09.vue?vue&type=style&index=0&id=45c9fd9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c9fd9a"]])

export default __exports__